namespace ui
{
	export namespace tree
	{
		export abstract class AbstractNode
			extends ui.base.BaseHTMLElement
		{
			public		readonly	UUID:			string;
			protected						m_Nodes:	AbstractNode[];
			private							m_TView:	JQuery|ui.base.BaseHTMLElement;

			public constructor( tagName: string, root: JQuery|ui.base.BaseHTMLElement )
			{
				super( tagName );

				this.m_Nodes	= new Array();
				this.UUID			= ui.utils.UUID.Gen();
				this.m_TView	= root;
			}

			public rebuild(): void
			{
				this.appendTo( this.m_TView );

				this.m_Nodes.forEach( ( node: AbstractNode ) => node.rebuild() );
			}

			public remNode( node: AbstractNode ): void
			{
				this.m_Nodes.forEach(
					( _node: AbstractNode, index: number ) =>
					{
						if ( _node.UUID === this.UUID )
						{
							this.m_Nodes = this.m_Nodes.splice( index, 1 );

							return;
						}

						_node.remNode( node );
					}
				);
			}

			protected addNode( node: AbstractNode ): void
			{
				this.m_Nodes.push( node );
			}
		}
	}
}
